import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import { Router } from "@angular/router";
import { AuthenticationService } from "../_services/authentication.service";
import { Helpers } from "../../helpers";
import { environment } from "../../../environments/environment";
import { CookieService } from "ngx-cookie-service";
import { DecryptPipe } from '../../auth/_services/encrypt-decrypt.pipe';

@Component({
    selector: 'app-logout',
    templateUrl: './logout.component.html',
    encapsulation: ViewEncapsulation.None,
})

export class LogoutComponent implements OnInit {
    isTransporter: boolean = false;
    isCustomer: boolean = false;

    constructor(private _router: Router,
        private _authService: AuthenticationService,
        private cookieService: CookieService,
        private decryptpipe: DecryptPipe) {
    }

    ngOnInit(): void {
        this.isTransporter = JSON.parse(localStorage.getItem("isTransporter"));
        this.isCustomer = JSON.parse(localStorage.getItem("isCustomer"));
        Helpers.setLoading(true);
        // reset login status
        this._authService.logout();
        if (environment.apiUrl == 'https://nol.ifreightbox.net/') {
            if (this.isTransporter || this.isCustomer) {
                this._router.navigate(["/home"]);
            } else {
                this._router.navigate(["/login"]);
            }
        }
        else {
            //add vithujan 02-08-2022
            let UserRole = this.decryptpipe.transform(JSON.parse(this.cookieService.get("SetUserRole")));
            if (UserRole == '["Pre-Customer"]') {
                this._router.navigate(["/home/tabs/login/customer"]);
            } else {
                this._router.navigate(["/login"]);
            }
        }
        // added by vithujan 28-12-2022
        this.cookieService.deleteAll();
        //end
    }
}